(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.header = null;
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.stickyStart = Number.POSITIVE_INFINITY;
      this.triggerElement = null;
      this.predictiveSearch = null;
      this.resizeObserver = null;
      this.isCollectionPage = false;
      this.ticking = false;
    }

    connectedCallback() {
      this.header =
        this.closest('.section-header') ||
        document.querySelector('.section-header');

      if (!this.header) {
        return;
      }

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.predictiveSearch =
        this.querySelector('predictive-search');

      this.setHeaderHeight();
      this.createHeaderObserver();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add(
          'shopify-section-header-sticky'
        );
      }

      this.onScrollHandler =
        this.onScroll.bind(this);

      this.onResizeHandler =
        this.onResize.bind(this);

      this.onReadyHandler =
        this.setupTrigger.bind(this);

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        { passive: true }
      );

      window.addEventListener(
        'resize',
        this.onResizeHandler,
        { passive: true }
      );

      window.addEventListener(
        'load',
        this.onReadyHandler
      );

      document.addEventListener(
        'shopify:section:load',
        this.onReadyHandler
      );

      if (document.readyState === 'loading') {
        document.addEventListener(
          'DOMContentLoaded',
          this.onReadyHandler,
          { once: true }
        );
      } else {
        this.setupTrigger();
      }
    }

    disconnectedCallback() {
      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );

      window.removeEventListener(
        'resize',
        this.onResizeHandler
      );

      window.removeEventListener(
        'load',
        this.onReadyHandler
      );

      document.removeEventListener(
        'shopify:section:load',
        this.onReadyHandler
      );

      document.removeEventListener(
        'DOMContentLoaded',
        this.onReadyHandler
      );

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    setHeaderHeight() {
      if (!this.header) {
        return;
      }

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    createHeaderObserver() {
      const observer =
        new IntersectionObserver((entries) => {
          this.headerBounds =
            entries[0].intersectionRect;

          observer.disconnect();
        });

      observer.observe(this.header);
    }

    findTriggerElement() {
      const path =
        window.location.pathname;

      const pageType =
        this.getAttribute('data-page-type');

      const isHomepage =
        pageType === 'index' ||
        path === '/';

      const isProductPage =
        pageType === 'product' ||
        path.includes('/products/');

      const isCollectionPage =
        pageType === 'collection' ||
        path.includes('/collections/');

      this.isCollectionPage =
        isCollectionPage;

      if (isHomepage) {
        return (
          document.querySelector(
            '#MainContent [id*="liora_hero"]'
          ) ||
          document.querySelector(
            '#MainContent [id*="hero"]'
          ) ||
          document.querySelector(
            '#MainContent .liora-hero'
          ) ||
          document.querySelector(
            '#MainContent slideshow-component'
          ) ||
          document.querySelector(
            '#MainContent .banner'
          ) ||
          document.querySelector(
            '#MainContent > .shopify-section:first-child'
          )
        );
      }

      if (isProductPage) {
        return (
          document.querySelector(
            'media-gallery .product__media-item:first-child'
          ) ||
          document.querySelector(
            '.product__media-wrapper .product__media-item:first-child'
          ) ||
          document.querySelector(
            '.product__media-wrapper .product__media:first-child'
          ) ||
          document.querySelector(
            'media-gallery'
          ) ||
          document.querySelector(
            '.product__media-wrapper'
          )
        );
      }

      if (isCollectionPage) {
        return (
          document.querySelector(
            '#MainContent .lora-sale-image'
          ) ||
          document.querySelector(
            '#MainContent .lora-sale-banner > img'
          ) ||
          document.querySelector(
            '#MainContent .lora-sale-banner'
          ) ||
          this.header
        );
      }

      return this.header;
    }

    setupTrigger() {
      this.triggerElement =
        this.findTriggerElement();

      this.calculateStickyStart();
      this.observeTrigger();
      this.onScroll();
    }

    calculateStickyStart() {
      if (!this.triggerElement) {
        this.stickyStart =
          this.header.offsetTop +
          this.header.offsetHeight;

        return;
      }

      const rect =
        this.triggerElement.getBoundingClientRect();

      this.stickyStart =
        window.scrollY + rect.bottom;
    }

    observeTrigger() {
      if (
        !this.triggerElement ||
        typeof ResizeObserver === 'undefined'
      ) {
        return;
      }

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      this.resizeObserver =
        new ResizeObserver(() => {
          this.setHeaderHeight();
          this.calculateStickyStart();
          this.onScroll();
        });

      this.resizeObserver.observe(
        this.triggerElement
      );
    }

    onResize() {
      this.setHeaderHeight();
      this.setupTrigger();
    }

    lockHeaderVisible() {
      this.header.classList.add(
        'liora-sticky-locked',
        'scrolled-past-header',
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    unlockHeader() {
      this.header.classList.remove(
        'liora-sticky-locked'
      );
    }

    applyCollectionImageGate(scrollTop) {
      const hasCollectionImage =
        this.isCollectionPage &&
        this.triggerElement &&
        this.triggerElement !== this.header;

      if (!hasCollectionImage) {
        this.header.classList.remove(
          'liora-collection-image-gate',
          'liora-collection-image-hidden'
        );

        return false;
      }

      this.header.classList.add(
        'liora-collection-image-gate'
      );

      if (scrollTop >= this.stickyStart) {
        this.header.classList.remove(
          'liora-collection-image-hidden'
        );

        this.lockHeaderVisible();

        return true;
      }

      this.unlockHeader();

      this.header.classList.remove(
        'scrolled-past-header',
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

      if (scrollTop > 1) {
        this.header.classList.add(
          'liora-collection-image-hidden'
        );
      } else {
        this.header.classList.remove(
          'liora-collection-image-hidden'
        );
      }

      return true;
    }

    applyNormalStickyBehaviour(scrollTop) {
      const headerBottom =
        Number.isFinite(this.headerBounds.bottom)
          ? this.headerBounds.bottom
          : this.header.offsetHeight;

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > headerBottom
      ) {
        this.header.classList.add(
          'scrolled-past-header'
        );

        if (!this.headerIsAlwaysSticky) {
          this.header.classList.add(
            'shopify-section-header-hidden',
            'shopify-section-header-sticky'
          );
        }
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > headerBottom
      ) {
        this.header.classList.add(
          'scrolled-past-header',
          'shopify-section-header-sticky',
          'animate'
        );

        this.header.classList.remove(
          'shopify-section-header-hidden'
        );
      } else if (scrollTop <= 0) {
        this.header.classList.remove(
          'scrolled-past-header',
          'shopify-section-header-hidden',
          'animate'
        );

        if (!this.headerIsAlwaysSticky) {
          this.header.classList.remove(
            'shopify-section-header-sticky'
          );
        }
      }
    }

    updateHeader() {
      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) {
        return;
      }

      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      const collectionGateHandled =
        this.applyCollectionImageGate(scrollTop);

      if (!collectionGateHandled) {
        if (scrollTop >= this.stickyStart) {
          this.lockHeaderVisible();
        } else {
          this.unlockHeader();
          this.applyNormalStickyBehaviour(scrollTop);
        }
      }

      this.currentScrollTop =
        scrollTop;
    }

    onScroll() {
      if (this.ticking) {
        return;
      }

      this.ticking = true;

      window.requestAnimationFrame(() => {
        this.updateHeader();
        this.ticking = false;
      });
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define(
      'sticky-header',
      StickyHeader
    );
  }

  } catch(e) { console.error(e); }
})();
})();
